import { Group, Button, Text } from '@mantine/core';
import type { EvidenceActionsConfig, EnrichedEvidence } from './types';

export function DiscoveryEvidenceActions({
  evidence,
  config,
}: {
  evidence: EnrichedEvidence;
  config: EvidenceActionsConfig;
}) {
  const id = String(evidence._id);

  if (config.mode === 'readonly') {
    return null;
  }

  if (config.mode === 'generated') {
    return (
      <Group spacing="xs" mt="md">
        <Text size="sm" c="dimmed">
          Use idea workflows to assign this evidence.
        </Text>
      </Group>
    );
  }

  return (
    <Group spacing="xs" mt="md">
      {config.onValidate && (
        <Button size="xs" variant="light" onClick={() => config.onValidate?.(id)}>
          Validate
        </Button>
      )}
      {config.onDismiss && (
        <Button size="xs" variant="outline" color="red" onClick={() => config.onDismiss?.(id)}>
          Dismiss
        </Button>
      )}
      {config.onUnassign && (
        <Button size="xs" variant="subtle" onClick={() => config.onUnassign?.(id)}>
          Unassign
        </Button>
      )}
    </Group>
  );
}
